/**
 * SidebarSubnavigationLink
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import { pushWithStoredSearch } from '../../../../../../services/router/actions';

// Selectors
import { makeSelectIsActive } from './selectors';

// Styles
import './styles.scss';

interface Props {
    title: React.Node | string;
    pathname?: string;
    pushWithStoredSearch: Function;
    isActive: boolean;
    onClick: Function;
}

export class SidebarSubnavigationLink extends React.PureComponent<Props> {
    handleClick = (event: SyntheticEvent<EventTarget>) => {
        event.preventDefault();
        const { pathname, onClick } = this.props;
        this.props.pushWithStoredSearch(pathname);
        if (onClick) {
            onClick();
        }
    };

    render() {
        const { pathname, title, isActive } = this.props;

        return (
            <a
                href={pathname}
                onClick={this.handleClick}
                className={[
                    'sidebar-subnavigation-link',
                    isActive ? 'selected' : ''
                ].join(' ')}
            >
                {title}
            </a>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isActive: makeSelectIsActive()
});

export default connect(
    mapStateToProps,
    { pushWithStoredSearch }
)(SidebarSubnavigationLink);
